export const addressFields = [
  ["city", "Ciudad", "cityInput"],
  ["street", "Calle", "streetInput"],
  ["number", "Número", "numberInput"],
  ["zipCode", "Código postal", "cpInput"],
  ["floor", "Piso", "flatInput"],
  ["door", "Puerta", "doorInput"],
  ["block", "Bloque", "flatBlockInput"],
];
const address = (raw) =>
  Object.fromEntries(
    addressFields.map(([key]) => [
      key,
      String(
        (key === "zipCode" ? (raw?.zipCode ?? raw?.postalCode) : raw?.[key]) ??
          "",
      ),
    ]),
  );
export const storeRecord = (raw) => {
  if (!raw || typeof raw !== "object" || Array.isArray(raw))
    throw new Error("Invalid corporation");
  const shipping = address(
    raw.addresses?.shippingAddresses?.[0] || raw.addresses?.addresses?.[0],
  );
  const billing = address(
    raw.addresses?.billingAddresses?.[0] || raw.addresses?.legalAddresses?.[0],
  );
  return {
    raw,
    draft: {
      name: raw.name || "",
      legalName: raw.legalName || "",
      nif: raw.nif || "",
      email: raw.email || "",
      phone: raw.phone || "",
      shipping,
      billing,
      same: JSON.stringify(shipping) === JSON.stringify(billing),
    },
  };
};
export const storePayload = (draft, raw) => {
  const addresses = raw.addresses || {};
  const mergeAddress = (original, fields) => [
    { ...original?.[0], ...fields, postalCode: fields.zipCode },
    ...(original?.slice(1) || []),
  ];
  return {
    name: draft.name,
    legalName: draft.legalName,
    nif: draft.nif,
    email: draft.email,
    phone: draft.phone,
    currency: raw.currency || "EUR",
    addresses: {
      ...addresses,
      shippingAddresses: mergeAddress(
        addresses.shippingAddresses || addresses.addresses,
        draft.shipping,
      ),
      billingAddresses: mergeAddress(
        addresses.billingAddresses || addresses.legalAddresses,
        draft.same ? draft.shipping : draft.billing,
      ),
    },
  };
};
export const addressSummary = (a) =>
  [
    a.street,
    a.number,
    a.floor && `${a.floor}º`,
    a.door,
    a.block && `Bloque ${a.block}`,
    a.zipCode,
    a.city,
  ]
    .filter(Boolean)
    .join(" ");

export const sameStore = (left, right) => {
  const canonical = ({ same, ...draft }) => ({
    ...draft,
    billing: same ? draft.shipping : draft.billing,
  });
  return JSON.stringify(canonical(left)) === JSON.stringify(canonical(right));
};
